<template>
  <v-autocomplete
    v-model="collaborators"
    :items="members"
    :loading="loading"
    :search-input.sync="searchInput"
    label="Collaborators"
    item-text="full_name"
    item-value="id"
    autocomplete="off"
    outlined
    dense
    multiple
    hide-details
    chips
    class="app-select assign-to-member v-text-field--no-line"
    style="width: 100%"
    @change="searchInput = ''"
  >
    <template #selection="{ item }">
      <CommonChip close @click:close="removeHandler(item.id)">
        {{ item.full_name }}
      </CommonChip>
    </template>
  </v-autocomplete>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';

export default Vue.extend({
  name: 'CollaboratorsSelect',

  components: { CommonChip },

  props: {
    value: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    members: {
      type: Array as PropType<{id: number; full_name: string}[]>,
      default: () => [],
    },
    loading: Boolean,
  },

  data: (): { searchInput: string } => ({
    searchInput: '',
  }),

  computed: {
    collaborators: {
      get (): number[] {
        return this.value;
      },
      set (value: number[]) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    removeHandler (id: number) {
      const newValue = this.collaborators.filter((collaboratorId) => collaboratorId !== id);
      this.$emit('input', newValue);
    },
  }
});
</script>
